module.exports = __webpack_public_path__ + "img/multi_user_selected_mobile.bc2a0c94.svg";